/* eslint-disable @typescript-eslint/prefer-optional-chain */

'use client'

import { NEWCAR_SEM_PAGE, widgetsProductType } from '@configs/components.config'
import { getCookie } from 'cookies-next'
import { getTrackerId } from '@utils/utils'
import { TENANT_TYPE } from '@components/Ackodrive/common/constants'
import isMobile from 'ismobilejs'
import { Lob } from 'src/enums/Lob'
import { SEGMENT_TITLE_CONFIG } from '@constants/businessSegmentEvent'
import { getPlatform } from '@configs/platform.config'
import { SearchParamKey } from '@enums/SearchParamKey'
import { fetchVasWidgetType } from '@configs/segmentEvents.config'
import { ENTERPRISE_HOME_PAGE, VIEW_PAGE_ENTERPRISE_LANDING } from '@constants/enterpriseSegmentData'
import { getR2d2Payload } from './r2d2Payload'
import { checkIsLoggedIn } from './client/isLoggedIn'

export const getDevicePlatform = () => {
  const isMobileDevice = isMobile(navigator.userAgent).any
  return !isMobileDevice ? 'web' : getCookie('webview') ? 'app' : 'mweb'
}

export const getCurrentSegment = () => {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname
    const segments = path.split('/').filter(Boolean)
    if (segments.length === 1 && segments[0] === 'business') {
      return 'main'
    } else if (segments.length === 2 && segments[0] === 'business') {
      return SEGMENT_TITLE_CONFIG[segments[1]].title
    }
  }
  return null
}

export const getDeviceModel = () => {
  if (typeof window !== 'undefined') {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera
    if (/android/i.test(userAgent)) {
      return 'Android'
    } else if (/iPad|iPhone|Mac|iPod/.test(userAgent) && !(window as any).MSStream) {
      return 'iOS'
    }
  }
  return 'Unknown'
}

const getUserDetails = async () => {
  const { user } = await checkIsLoggedIn()
  return user
}

export const enterpriseCommonProps = () => {
  const userData: any = getUserDetails()
  const deviceType = getDeviceModel()

  let url = ''
  let source = ''
  let pathname = ''
  let segments = [] as string[]

  if (typeof window !== 'undefined') {
    url = window.location.href || ''
    source = document.referrer || ''
    pathname = window.location.pathname
    segments = pathname.split('/').filter(Boolean)
  }

  const queryParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null
  const category = segments?.length > 1 ? segments[1] : ''

  return {
    device_model: deviceType,
    phone: userData?.phone || '',
    email: userData?.email || '',
    dob: userData?.date_of_birth || '',
    address: userData?.addresses?.[0] || {},
    from_page: source,
    page: category || ENTERPRISE_HOME_PAGE,
    platform: getDevicePlatform(),
    utm_source: queryParams ? queryParams.get('utm_source') || '' : '',
    utm_campaign: queryParams ? queryParams.get('utm_campaign') || '' : '',
    utm_content: queryParams ? queryParams.get('utm_content') || '' : '',
    utm_medium: queryParams ? queryParams.get('utm_medium') || '' : '',
    utm_term: queryParams ? queryParams.get('utm_term') || '' : '',
    url,
    view_name: category ? `view_page_${category?.replaceAll('-', '_')}` : VIEW_PAGE_ENTERPRISE_LANDING,
  }
}

export const segmentEventCommonPropFunc = async propertiesObject => {
  const { productWidgetData, contentfulTagNames, product: productName = null, page_type: pageType = null } = propertiesObject
  const contentfulTagNamesArray = contentfulTagNames ? contentfulTagNames?.split(',') : []

  const { user: userData } = await checkIsLoggedIn()
  const pageWidget = productWidgetData?.Content?.data?.attributes?.widget
  const pageTitle = productWidgetData?.Content?.data?.attributes?.productWidgetMainHeading

  const userTrackerId = getTrackerId(TENANT_TYPE.ACKOSEO)
  const additionalProps = {
    contentful_tag_names: contentfulTagNamesArray,
    widget_type: fetchVasWidgetType?.[pageWidget] || 'SEO revamp widget',
    tracker_id: userTrackerId,
    ...(productName && { product: productName }),
    ...(pageWidget === NEWCAR_SEM_PAGE && { page_type: pageType || 'new_car_comparison' }),
  }
  let path = ''
  let source = ''

  if (typeof window !== 'undefined') {
    path = window.location.href || ''
    source = document.referrer || ''
  }

  const queryParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null

  return {
    address: userData?.addresses?.[0] || {},
    dob: userData?.date_of_birth || '',
    email: userData?.email || '',
    from_page: source,
    journey: pageTitle || '',
    path,
    product: widgetsProductType[pageWidget] || pageTitle || '',
    page: path,
    phone: userData?.phone || '',
    platform: getDevicePlatform(),
    source,
    utm_source: queryParams ? queryParams.get('utm_source') || '' : '',
    utm_campaign: queryParams ? queryParams.get('utm_campaign') || '' : '',
    utm_content: queryParams ? queryParams.get('utm_content') || '' : '',
    utm_medium: queryParams ? queryParams.get('utm_medium') || '' : '',
    utm_term: queryParams ? queryParams.get('utm_term') || '' : '',
    url: path,
    ...additionalProps,
  }
}

enum Platform {
  App = 'app',
  MWeb = 'mweb',
  Web = 'web',
}

export const fuelSegmentEventCommonPropFunc = async (additionalProps = {}) => {
  const isMobileDevice = isMobile(navigator.userAgent).any
  const { user: userData } = await checkIsLoggedIn()
  const isWebView = getCookie('webview')

  function getPlatform(): Platform {
    if (!isMobileDevice) {
      return Platform.Web
    } else if (isWebView) {
      return Platform.App
    } else {
      return Platform.MWeb
    }
  }

  return {
    address: (userData?.addresses && userData?.addresses[0]) || {},
    dob: userData?.date_of_birth || '',
    email: userData?.email || '',
    from_page: (typeof document !== 'undefined' && document.referrer) || '',
    path: typeof window !== 'undefined' && window?.location?.href,
    product: 'Fuel Price',
    page: typeof window !== 'undefined' && window?.location?.href,
    platform: getPlatform(),
    source: (typeof document !== 'undefined' && document.referrer) || '',
    ...additionalProps,
  }
}

export const semAutoR2d2properties = product => ({
  googleRecaptcha: {},
  is_renewable: false,
  journey: product === Lob.CAR ? 'old_car' : 'old_bike',
  lob: 'direct',
  pa_cover: false,
  screen: 'registration_number_screen',
  tenure: 1,
})

const lobSegmentEkind = {
  [Lob.CAR]: 'landing_screen_loaded',
  [Lob.BIKE]: 'bike_landing_screen_loaded',
}
const lobSegmentJourney = {
  [Lob.CAR]: 'buy fresh car',
  [Lob.BIKE]: 'buy fresh bike',
}

const getAutoSegmentEventProperties = async (isSemPage, product) => {
  const path = window?.location?.pathname || ''
  const url = window?.location?.href || ''
  const { isLoggedIn } = await checkIsLoggedIn()

  return {
    landing_page: path,
    language: 'en',
    mobile_verified: isLoggedIn,
    page_link: url,
    partner_widget: false,
    ...(isSemPage ? { journey: lobSegmentJourney[product] } : {}),
    ...getR2d2Payload({
      isSemPage,
      ekind: isSemPage ? lobSegmentEkind[product] : 'product_page_loaded',
      edata: isSemPage ? semAutoR2d2properties(product) : {},
      odata: { product },
    }),
  }
}

export const lobSegmentEventProperties = {
  [Lob.CAR]: isSemPage => getAutoSegmentEventProperties(isSemPage, Lob.CAR),
  [Lob.BIKE]: isSemPage => getAutoSegmentEventProperties(isSemPage, Lob.BIKE),
}

export const segmentEventCommonPropFuncAckoDrive = ({ pageType }) => {
  const isMobileDevice = isMobile(navigator.userAgent).any
  const refereshAccessToken: any = getCookie('ackodrive_tokens') || '{}'
  const isLoggedIn = Object.keys(JSON.parse(decodeURIComponent(refereshAccessToken))).length

  const userTrackerId = getCookie('eventTrackerUserId')

  const fullName = localStorage.getItem('login_full_name')
  const email = localStorage.getItem('login_email_id')
  const mobileNumber = localStorage.getItem('mobileNumber') || ''

  let path = ''
  let source = ''

  if (typeof window !== 'undefined') {
    path = window.location.href || ''
    source = document.referrer || ''
  }

  const queryParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null

  return {
    customer_name: fullName || '',
    email: email || '',
    journey: 'Home Page',
    logged_in: isLoggedIn,
    page: path,
    pageType: pageType || '',
    path,
    phone: mobileNumber,
    platform: !isMobileDevice ? 'web' : getCookie('webview') ? 'app' : 'mweb',
    referrer: source,
    resource_id: userTrackerId,
    search: '',
    source,
    title: '',
    url: path,
    utm_source: queryParams ? queryParams.get('utm_source') || '' : '',
    utm_campaign: queryParams ? queryParams.get('utm_campaign') || '' : '',
    utm_content: queryParams ? queryParams.get('utm_content') || '' : '',
    utm_medium: queryParams ? queryParams.get('utm_medium') || '' : '',
    utm_term: queryParams ? queryParams.get('utm_term') || '' : '',
  }
}
export const homePageCommonProps = () => ({
  platform: getDevicePlatform(),
  page_type: 'acko_home_page',
  experiment_name: 'wrapper_v1',
})

export const rewardsPageProps = () => ({ platform: getDevicePlatform(), experiment_name: 'rewards_v2' })

export const savingsPageProps = () => ({ platform: getDevicePlatform(), experiment_name: 'savings_v1' })

export const getRewardsPagePropsObject = (isApp, isMobile) => ({
  platform: getPlatform({ isMobile, isApp }),
  experiment_name: 'rewards_v2',
})

export const getCommonSegmentEventPropertiesForReviewShare = () => {
  const searchParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null

  return {
    source: searchParams?.get(SearchParamKey.SOURCE) || '',
    email: searchParams?.get(SearchParamKey.USER_EMAIL) || '',
    policy_number: searchParams?.get(SearchParamKey.POLICY_ID) || '',
    comment: searchParams?.get(SearchParamKey.USER_FEEDBACK) || '',
    claim_id: searchParams?.get(SearchParamKey.CLAIM_ID) || '',
    lob: searchParams?.get(SearchParamKey.LOB) || '',
    type: searchParams?.get(SearchParamKey.FORM) || '',
  }
}
